<template>
  <div class="goodsManageAddPage">
    <div class="my-swipe">
      <van-image width="100%" fit="scale-down" :src="detail.cover" />
    </div>

    <div class="main_content">
      <div class="good_description">
        <div class="item">
          <p>内容所属系列：{{ detail.typeidstr }}</p>
          <p>序号：{{ detail.klno }}</p>
          <p>所属企业：{{ detail.qyguidstr }}</p>
          <p>内容标签：{{ detail.topic }}</p>
          <p>属性：{{ detail.attrvalstr }}</p>
        </div>
        <div class="item">
          <div class="block">
            <p>内容收费价格：{{ detail.price }}</p>
            <p>是否启用：{{ detail.isuse }}</p>
            <p>发布时间：{{ detail.publishdate | formatDate }}</p>
            <p>创建者：{{ detail.creater }}</p>
          </div>
        </div>
      </div>

      <div class="good_operation flex-between">
        <a
          href="javascript:;"
          class="item"
          @click="handleGo(detail.id, 'kBaseinfo')"
          >基础信息设置</a
        >
        <a
          href="javascript:;"
          class="item"
          @click="handleGo(detail.id, 'kDetail')"
          >内容详情</a
        >
        <a
          href="javascript:;"
          class="item"
          @click="handleGo(detail.id, 'kVideoList')"
          >内容视频链接</a
        >
        <a
          href="javascript:;"
          class="item"
          @click="handleGo(detail.id, 'kBuyadd')"
          >用户购买记录</a
        >
        <a
          href="javascript:;"
          class="item"
          @click="handleGo(detail.id, 'kVisitlist')"
          >用户观看记录</a
        >
      </div>
    </div>
    <div class="fixd_button_btm flex-rowl">
      <!-- <div class="return-fixd"> -->
      <div class="item return" @click="handleReturn">返回</div>
    </div>
  </div>
</template>

<script>
import { encryptstringadd, encryptstringview } from "../../api/api";
import { getKonwledgeDetail } from "../../api/knowledge";
import { mapState } from "vuex";
export default {
  name: "kManageDetail",
  data() {
    return {
      id: "",
      tabbarActive: 0,
      bannerList: "", // 商品banner
      brandList: "", // 品牌列表
      shopLabelFirst: "", // 商品所属分类
      detail: "", // 详情列表

      cmid: "",
      qyid: 0,
      qyguid: "",
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  created() {
    let { routerList, USERINFO } = this.$store.state;
    let { name } = this.$route;
    if (USERINFO.qy) {
      this.qyid = USERINFO.qy.id;
      this.qyguid = USERINFO.qy.qyguid;
    } else {
      this.qyid = 0;
      this.qyguid = 0;
    }

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.getDetail(id);
      } else {
        this.$router.back();
      }
    },

    getDetail(id) {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getKonwledgeDetail({ id }).then((res) => {
        this.detail = res;
        Toast.clear();
      });
    },

    handleReturn() {
      history.back();
    },

    handleGo(id, name) {
      this.encryptstringadd(name, { id });
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.goodsManageAddPage {
  font-size: 26px;
  color: #404d6c;
  padding-bottom: 210px;
  .my-swipe {
    background: #f8f8f8;
  }
  .good_description {
    padding: 96px 70px 150px;
    .item {
      margin-bottom: 38px;
      p {
        margin-bottom: 15px;
      }
    }
  }
  .good_operation {
    font-size: 26px;
    color: #eb1b3d;
    flex-flow: row wrap;
    margin-bottom: 180px;
    a {
      color: #eb1b3d;
    }
    .item {
      flex-shrink: 0;
      width: 50%;
      text-align: center;
      height: 90px;
      line-height: 90px;
      border-bottom: 1px solid #adadad;
      box-sizing: border-box;
      &:nth-child(2n-1) {
        border-right: 1px solid #adadad;
      }
      &:nth-child(1),
      &:nth-child(2) {
        border-top: 1px solid #adadad;
      }
    }
  }
  .fixd_button_btm {
    .item {
      flex: 1;
    }
  }
}
</style>